export default "__VITE_ASSET__yXJxL3h1__"